import { render, staticRenderFns } from "./AgrBox.vue?vue&type=template&id=6d959694&scoped=true&"
import script from "./AgrBox.vue?vue&type=script&lang=js&"
export * from "./AgrBox.vue?vue&type=script&lang=js&"
import style0 from "./AgrBox.vue?vue&type=style&index=0&id=6d959694&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d959694",
  null
  
)

export default component.exports